<template>
<!-- Header -->
<div class="header" id="heading">

	<!-- Logo -->
	<div class="header-left">
		<router-link to="/index" class="logo">
			<img src="@/assets/img/dkl.png"  alt="Logo" class="sidebar-logo">
			<img src="@/assets/img/dkl_favicon.png"  alt="Logo" class="mini-sidebar-logo">
		</router-link>
	</div>
	<!-- /Logo -->

	<a id="toggle_btn" href="javascript:void(0);">
		<span class="bar-icon">
			<span></span>
			<span></span>
			<span></span>
		</span>
	</a>

	<!-- Header Title -->
	<div class="page-title-box">
		<div class="top-nav-search vertical-center">
				<a href="javascript:void(0);" class="responsive-search">
					<i class="fa fa-search"></i>
			   </a>
        <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
          <div class="col  p-0">
            <h3 class="page-title m-0">{{mandant_name}} </h3>
          </div>
        </a>
        <div class="dropdown-menu">
          <router-link class="dropdown-item" to="/select-mandant">{{ $t('switch_client') }}</router-link>
        </div>
			</div>
	</div>
	<!-- /Header Title -->

	<a id="mobile_btn" class="mobile_btn" href="#sidebar"><i class="fa fa-bars"></i></a>

	<!-- Header Menu -->
	<ul class="nav user-menu">

		<!-- Search -->
		<li class="nav-item">
      <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button">
        <div><i class="fa fa-info" style="color:green;"></i><span class="ml-2">{{ $t('abbreviations') }}</span></div>
      </a>
      <div class="dropdown-menu dropdown-menu-right">
          <div class="dropdown-item" v-for="item in currentAbbreviations" :key="item.id"><span>{{item.id}}</span> | <span>{{ item.text }}</span></div>
      </div>
		</li>
		<!-- /Search -->

		<!-- Flag -->
    <li class="nav-item dropdown has-arrow flag-nav">
      <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button">
        <img :src="langSrc" alt="" height="20"> <span>{{ currentLanguage }}</span>
      </a>
      <div class="dropdown-menu dropdown-menu-right">
        <a href="javascript:void(0);" class="dropdown-item" @click.prevent="changeLocale('de')">
          <img :src="deLangSrc" alt="" height="16"> Deutsch
        </a>
        <a href="javascript:void(0);" class="dropdown-item" @click.prevent="changeLocale('en')">
          <img :src="enLangSrc" alt="" height="16"> English
        </a>
      </div>
    </li>
		<!-- /Flag -->

		<li class="nav-item dropdown has-arrow main-drop">
			<a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
				<span class="user-img"><img :src="avatar" alt="">
				<span class="status online"></span></span>
				<span>{{ username }}</span>
			</a>
      <div class="dropdown-menu dropdown-menu-right">
        <router-link class="dropdown-item" to="/settings">Settings</router-link>
        <a class="dropdown-item" href="#" @click="logout">Logout</a>
      </div>
		</li>
	</ul>
	<!-- /Header Menu -->

</div>
<!-- /Header -->
</template>
<script>
  import { service } from "@/utils/request";
  import { getAbbreviations } from "@/utils";
  import {mapMutations, mapState} from "vuex";
  export default {
    data() {
        return {
          mandant_name: this.$store.getters.accountName,
          deLangSrc: require("@/assets/img/flags/de.png"),
          enLangSrc: require("@/assets/img/flags/us.png"),
        }
      },
    mounted() {
      //mandant list select 2
      if ($('#mandanten_list').length > 0) {
        $('#mandanten_list').select2({
          minimumResultsForSearch: -1,
          width: '100%',
          ajax: {
            url: 'https://crm.dci-1.com/companies/',
            dataType: 'json',
            type: "GET",
            quietMillis: 50,
            data: function (params) {
              return {
                q: params.term
              };
            },
            processResults: function (data) {
              return {
                results: $.map(data, function (item) {
                  return {
                    text: item.name,
                    id: item.id
                  }
                })
              };
            }
          }
        });
      }
      if (this.abbreviations.length === 0) getAbbreviations()
    },
    computed: {
      ...mapState({username: state => state.user.username, avatar: state => state.user.avatar, abbreviations: state => state.account.abbreviations, language: state => state.app.language}),
       currentPath() {
        return this.$route.name
       },
      currentAbbreviations() {
        return this.abbreviations.filter(abbreviation => abbreviation.language === this.language);
      },
      currentLanguage() {
        return this.language === 'de' ? 'Deutsch' : 'English'
      },
      langSrc() {
        return this.language === 'de' ? this.deLangSrc : this.enLangSrc
      },
     },
    methods: {
      ...mapMutations({setLanguage: 'SET_LANGUAGE'}),
      changeLocale(language) {
        this.$i18n.locale = language;
        this.langSrc = language === 'de' ? this.deLangSrc : this.enLangSrc;
        this.currentLanguage = language === 'de' ? 'Deutsch' : 'English';
        this.setLanguage(language);
        this.$emit('changedLanguage');
      },
      logout(e) {
        e.preventDefault()
        this.$store.commit('RESET_ACCOUNT')
        this.$store.commit('RESET_USER')
        this.$store.commit('RESET_LANGUAGE')
        service.request({
          url: 'logout/',
          method: 'GET',
        }).then(response => {
          if (response.data === 'User logged out successfully')
            this.$vToastify.success('Abmeldung erfolgreich!')
        }).finally(() => this.$router.push('/'))
      }
    }
  }
</script>
<style scoped>
  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
</style>
